import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "card-panel" }
const _hoisted_2 = { class: "collection" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.trackList, (track) => {
        return (_openBlock(), _createElementBlock("a", {
          href: "#!",
          key: track.name,
          class: _normalizeClass({ 'active': $setup.getCurrTrack() === track.index, 'collection-item': true }),
          onClick: ($event: any) => ($setup.updateCurrTrack(track.index))
        }, _toDisplayString(track.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}